import { buildColumns } from './columns';

export const useEnabledAvailableToBillListColumnGroups = editable => {
  const basicColumns = buildColumns({
    classes: {},
    editable
  });

  return {
    defaultColumns: Object.values(basicColumns)
      .filter(({ isDefault }) => isDefault)
      .map(({ field }) => field),
    enabledColumnGroups: [
      {
        id: 'basic',
        title: null,
        columns: Object.values(basicColumns)
      }
    ]
  };
};
